import { useState, useEffect, useContext } from "react";
import Modal from "../../../utils/components/Modal";
import SelectBox from "../../../utils/components/SelectBox";
import { useNavigate } from "react-router";
import API from "../../../utils/API";
import { auth } from "../../../App/routes";
import toastr from "toastr";
import { RequestContext } from "../../../utils/context/RequestContext";

const FormStartModal = ({
  show,
  hideModal,
  users = [],
  workflowTemplates,
  translate,
  handleSaveForm = null,
  template = null,
  isSendingFromParent,
  isSendingForm,
}) => {
  const [selectedWorkflowTemplate, setSelectedWorkflowTemplate] =
    useState(null);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [isSending, setIsSending] = useState(false);

  const navigate = useNavigate();
  // kullanıcılar şirket seçim şeklinde olacak

  const { setRequestLoading } = useContext(RequestContext);

  useEffect(() => {
    if (!show) {
      setSelectedWorkflowTemplate(null);
      setSelectedUsers([]);
    }
  }, [show]);

  const handleSubmit = (e) => {
    setRequestLoading(true);
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }

    const payload = {
      form_id: template ? parseInt(template) : null,
      workflow_template_id: selectedWorkflowTemplate.id,
      step_workers: selectedWorkflowTemplate.steps.map((step) => {
        return {
          step_name: step.code,
          users: selectedUsers[step.code].map((user) => {
            return user.value;
          }),
        };
      }),
    };

    if (handleSaveForm) handleSaveForm(payload, "workflow-start");
    else {
      setIsSending(true);

      API.postData("workflow/start", payload)
        .then(({ data: res }) => {
          toastr.success(res.message);
          navigate(auth.forms.link);
          hideModal("send");
        })
        .catch((err) => {
          toastr.error(err.message);
          setIsSending(false);
        });
    }
  };

  return (
    <Modal
      title={translate("forms.create-workflow")}
      positiveButtonNode={translate("send")}
      negativeButtonNode={translate("cancel")}
      positiveButtonHandler={handleSubmit}
      modalSize="xl"
      show={show}
      setShow={() => hideModal()}
      disableButtons={isSendingForm || isSendingFromParent || isSending}
    >
      <div className="my-4">
        <SelectBox
          options={
            workflowTemplates &&
            workflowTemplates.map((item) => ({
              value: item.id,
              label: item.name,
            }))
          }
          value={
            selectedWorkflowTemplate && {
              value: selectedWorkflowTemplate.id,
              label: selectedWorkflowTemplate.name,
            }
          }
          placeholder={translate(
            "forms.form-start-modal.select-workflow-placeholder"
          )}
          onChange={(selectedTemplate) => {
            workflowTemplates &&
              setSelectedWorkflowTemplate(
                workflowTemplates.find(
                  (item) => item.id === selectedTemplate.value
                )
              );
          }}
        />
      </div>

      <div>
        {selectedWorkflowTemplate?.image_url &&
          selectedWorkflowTemplate?.image_url !== "" && (
            <img
              src={selectedWorkflowTemplate.image_url}
              alt="workflow"
              className="w-100"
            />
          )}
      </div>

      {selectedWorkflowTemplate?.steps &&
        selectedWorkflowTemplate?.steps.map((step, index) => (
          <div className="my-5" key={index}>
            <p className="text-center fw-bold">{step.name}</p>
            <p className="text-uppercase mb-2">
              {translate("forms.form-start-modal.appointed-to-task")}
            </p>
            <SelectBox
              options={users}
              value={selectedUsers[step.code] && selectedUsers[step.code]}
              isMulti
              placeholder={translate("please_select")}
              onChange={(data) => {
                setSelectedUsers({
                  ...selectedUsers,
                  [step.code]: data,
                });
              }}
            />
          </div>
        ))}
    </Modal>
  );
};

export default FormStartModal;
